export const getExtraMailDisabledState = () => {
  return {
    isObjectDisabled: true,
    isBodyDisabled: true
  };
};
